module.exports = __webpack_public_path__ + "static/media/slices_2.d6c97de3.jpg";